// extracted by mini-css-extract-plugin
module.exports = {"formLabel":"_2dVCz"};